export default "__VITE_ASSET__ZIg7qTLw__"